export default __webpack_public_path__ + "static/media/get-live-help.bc767e30.svg";